<template>
    <div>
        <v-dialog
            v-model="inscriptionDialog"
            max-width="750"
            persistent
        >
            <MessageOverlay ref="overlay"/>
            <v-card>
                <v-card-title>
                    <span class="text-h5">You've been invited to join the organization : {{this.inscriptionItem.organization}}</span>
                    <span v-if="this.inscription" class="text-h5">Sign in with your informations</span>
                    <span class="text-h5">By clicking on validate you will automatically join the organization</span>
                </v-card-title>
                <v-card-text class="px-2 px-sm-6">
                    <div v-if="this.inscription" class="text-right text-subtitle-2 font-weight-regular mb-1">* {{ $vuetify.lang.t('$vuetify.invite.required') }}</div>
                    <v-form
                        ref="inscriptionForm"
                        v-model="inscriptionFormValidation"
                        lazy-validation
                        v-if="this.inscription"
                    >
                        <v-text-field
                            v-model="inscriptionItem.username"
                            required
                            outlined
                            clearable
                            :rules="nameRules"
                            :label="$vuetify.lang.t('$vuetify.invite.username') + '*'"
                        ></v-text-field>
                        <v-text-field
                            v-model="inscriptionItem.email"
                            required
                            outlined
                            disabled
                            :rules="emailRules"
                            :label="$vuetify.lang.t('$vuetify.invite.email') + '*'"
                            @input="isNewEmail = true"
                        ></v-text-field>
                        <vue-tel-input-vuetify
                            outlined
                            clearable
                            placeholder=""
                            appendIcon="$dropdown"
                            mode="international"
                            type="tel"
                            :value="inscriptionItem.phone"
                            :label="phoneInputLabel"
                            :select-label="countryInputLabel"
                            :valid-characters-only="true"
                            :error-messages="!isPhoneValid ? $vuetify.lang.t('$vuetify.invite.phonenumbermustbevalid') : ''"
                            @input="onTelephoneInput"
                        ></vue-tel-input-vuetify>
                        <v-text-field
                            v-model="newPassword.value"
                            outlined
                            required
                            :rules="newPassword.rules"
                            :label="$vuetify.lang.t('$vuetify.invite.newpassword')+'*'"
                            :type="newPassword.show ? 'text' : 'password'"
                            :append-icon="newPassword.focus ? newPassword.show ? 'mdi-eye-off' : 'mdi-eye' : undefined"
                            @click:append="newPassword.show = !newPassword.show"
                            @focus="newPassword.focus = true"
                            @blur="newPassword.focus = false"
                        ></v-text-field>
                        <v-text-field
                            v-model="confirmationPassword.value"
                            outlined
                            required
                            :rules="confirmationPassword.rules"
                            :label="$vuetify.lang.t('$vuetify.invite.passwordconfirmation')+'*'"
                            :type="confirmationPassword.show ? 'text' : 'password'"
                            :append-icon="confirmationPassword.focus ? confirmationPassword.show ? 'mdi-eye-off' : 'mdi-eye' : undefined"
                            @click:append="confirmationPassword.show = !confirmationPassword.show"
                            @focus="confirmationPassword.focus = true"
                            @blur="confirmationPassword.focus = false"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        :disabled="!inscriptionFormValidation || !isPhoneValid"
                        :class="{ 'gradient-wintech': (inscriptionFormValidation && isPhoneValid) }"
                        @click="validateInscription"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        {{ $vuetify.lang.t('$vuetify.invite.validate') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="openConfirmationDialog"
            max-width="650"
            persistent
        >
            <v-card>
                <v-card-title>
                    <span class="text-h5 mb-5">You are now part of the organization : {{this.inscriptionItem.organization}}</span>
                    <span class="text-h5">You can access UTC and other users by logging on</span>
                    <span class="text-h5">to UTC-SUPERVISION and selecting this organization</span>
                </v-card-title>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="invalidLink"
            max-width="500"
            persistent
        >
            <v-card>
                <v-card-title>
                    <span class="text-h5 mb-5">ERROR: the link is not or no longer valid</span>
                </v-card-title>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from 'axios';
    import { sha3_512 } from 'js-sha3';
    import MessageOverlay from './Overlay/MessageOverlay.vue';
    export default {
        name: "Invite",
        components: {MessageOverlay},
        data() {
            return {
                inscriptionDialog: true,
                inscription: false,
                inscriptionFormValidation: true,
                nameRules: [
                    v => !!v || this.$vuetify.lang.t('$vuetify.invite.nameisrequired'),
                ],
                inscriptionItem: {
                    username: '',
                    email: '',
                    phone: '',
                    password: '',
                    organization: '',
                    idUser: '',
                    idOrganization: ''
                },

                newPassword: {
                    value: "",
                    show: false,
                    focus: false,
                    rules: [
                        v => !!v ||  this.$vuetify.lang.t('$vuetify.invite.passwordisrequired'),
                        v => /^(?=.*[A-Z])/.test(v) || this.$vuetify.lang.t('$vuetify.invite.yourpasswordshouldcontainatleastoneuppercase'),
                        v => /^(?=.*\d)/.test(v) || this.$vuetify.lang.t('$vuetify.invite.yourpasswordshouldcontainatleastonedigit'),
                        v => /^(?=.*[a-z])/.test(v) || this.$vuetify.lang.t('$vuetify.invite.yourpasswordshouldcontainatleastonelowercase'),
                        v => /^(?=.*[!@#$%^&*])/.test(v) || this.$vuetify.lang.t('$vuetify.invite.yourpasswordmustcontainatleastonespecialcharacter'),
                        v => /^[a-zA-Z0-9!@#$%^&*]{8,}/.test(v) || this.$vuetify.lang.t('$vuetify.invite.yourpasswordshouldcontainatleast8characters'),
                    ]
                },
                confirmationPassword: {
                    value: "",
                    show: false,
                    focus: false,
                    rules: [
                        v => !!v ||  this.$vuetify.lang.t('$vuetify.invite.confirmationisrequired'),
                    ]
                },
                emailRules: [
                    v => !!v || 'Email is required'
                ],
                passwordRules: [
                    v => !!v || 'Password is required'
                ],
                openConfirmationDialog: false,
                invalidLink: false,
            }
        },
        async mounted() {
            try {
                const res = await axios.get('invite', { params: this.$route.query });
                this.inscriptionItem.email = res.data[0];
                this.inscriptionItem.organization = res.data[1];
                this.inscriptionItem.idUser = res.data[2];
                this.inscriptionItem.idOrganization = res.data[3];

                if(res.status == 201){
                    //Invitation need inscription
                    this.inscriptionDialog = true
                    this.inscription = true
                } else if(res.status == 200){
                    //Invitation
                    this.inscriptionDialog = true
                }
            } catch (error) {
                console.error(error);
                this.inscriptionDialog = false;
                this.invalidLink = true;
                
            }
        },
        computed: {
            isPhoneValid() {
                return this.inscriptionItem.phone === '' || this.isPhoneInputValid
            },
        },
        methods: {
            onTelephoneInput(formattedNumber, { number, valid }) {
                this.inscriptionItem.phone = "e164" in number ? number.e164 : number.input;
                this.isPhoneInputValid = valid;
            },
            async validateInscription() {
                try {
                    if (this.inscription && this.$refs.inscriptionForm.validate()) {
                        this.inscriptionItem.password = sha3_512(this.newPassword.value)
                        const data = {
                            ...this.inscriptionItem
                        }
                        const res = await axios.post('invite/newUser', data);
                        if (res.status == 200) {
                            this.endOverlay()
                            // this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.invite.onSupervision'))
                            
                        }
                    } else if(!this.inscription){
                        const data = {
                            idUser: this.inscriptionItem.idUser,
                            idOrganization: this.inscriptionItem.idOrganization
                        }
                        const res = await axios.post('invite/invitation', data);
                        if (res.status == 200) {
                            this.endOverlay()
                            // this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.invite.onOrgaSupervision'))
                        }
                    }
                } catch(error) {
                    if ('response' in error && error.response.status === 409) this.isNewEmail = false;
                    else {
                        this.closeInscriptionDialog();
                        this.showOverlay("error", error);
                    }
                }
            },
            closeInscriptionDialog() {
                this.inscriptionDialog = false;
                this.$nextTick(() => {
                    this.inscriptionItem = Object.assign({}, this.defaultItem)
                })
            },
            endOverlay() {
                this.inscriptionDialog = false;
                this.openConfirmationDialog=true;
            },
            countryInputLabel() {
                return this.$vuetify.lang.t('$vuetify.account.changePhoneNumber.country') ;
            },
            phoneInputLabel() {
                return this.$vuetify.lang.t('$vuetify.account.changePhoneNumber.phonenumber') ;
            },
        }
    }
</script>